export const gameWidth = 1920;
export const gameHeight = 1080;
export const gameRatio = gameHeight / gameWidth;

export const masterSceneKey = "master";
export const hubSceneKey = "hub";
export const menuSceneKey = "menu";
export const lightsSceneKey = "lights";
export const dungeonSceneKey = "dungeon";
export const creaturesSceneKey = "creatures";
export const finalSceneKey = "final";
